"use strict";

/**
 * Web and mobile footer banner
 */
;
(function () {
  // Call "onPageLoad" when page loaded and "Flix" object prepared
  document.addEventListener('flix:load', onPageLoad);
  // refresh banners after new related videos loaded
  document.addEventListener('flix:additional-related', onPageLoad);

  /**
   * Check if this ad should be shown
   * @returns boolean
   */
  function isEnabled() {
    return Flix.ads.enabled;
  }
  ;

  /**
   * Main logic
   */
  function onPageLoad() {
    if (!isEnabled()) {
      return;
    }
    if (FlixUtils.isMobile()) {
      loadForMobile();
    } else {
      loadForDesktop();
    }
  }
  ;
  function loadForMobile() {
    if (Flix.isTna()) {
      var code = "<iframe class=\"na\" frameborder=\"0\" scrolling=\"no\" width=\"300\" height=\"250\" sandbox=\"allow-scripts allow-popups allow-forms allow-same-origin\" \n                src=\"//a.shukriya90.com/api/spots/350754?p=1&s1=".concat(Flix.ads.iid, "&kw=").concat(Flix.ads.tags, "\"></iframe>");

      // if (Math.random() <= 0.25) {
      //     code = `<iframe width="300" height="250" scrolling="no" frameborder="0" src=https://a.adtng.com/get/10014190?time=1681490066345 allowtransparency="true" marginheight="0" marginwidth="0" name="spot_id_10014190"></iframe>`;
      // }
    } else {
      var code = "<iframe class=\"na\" frameborder=\"0\" scrolling=\"no\" width=\"300\" height=\"250\" sandbox=\"allow-scripts allow-popups allow-forms allow-same-origin\" \n                src=\"//a.shukriya90.com/api/spots/350855?p=1&s1=".concat(Flix.ads.iid, "&kw=").concat(Flix.ads.tags, "\"></iframe>");
    }
    code = '<div class="ad-logo">Ad</div>' + code;

    // On the video page before related
    if (document.querySelector('#bannerBlock_footer')) {
      document.querySelector('#bannerBlock_footer').innerHTML = code;
    }

    // On the very bottom either for mediabuys or if it's not a video page
    if (document.querySelector('#bannerBlock_footer2')) {
      document.querySelector('#bannerBlock_footer2').innerHTML = code;
    }
  }
  ;
  function loadForDesktop() {
    // Only on video page
    if (!document.querySelector('#desktop_video_footer_ad')) {
      return;
    }
    if (Flix.isTna()) {
      var code = "<iframe class=\"na\" frameborder=\"0\" scrolling=\"no\" width=\"900\" height=\"250\" sandbox=\"allow-scripts allow-popups allow-forms allow-same-origin\" \n                src=\"//a.shukriya90.com/api/spots/350559?p=1&s1=".concat(Flix.ads.iid, "&kw=").concat(Flix.ads.tags, "\"></iframe>");
    } else {
      var code = "<iframe class=\"na\" frameborder=\"0\" scrolling=\"no\" width=\"900\" height=\"250\" sandbox=\"allow-scripts allow-popups allow-forms allow-same-origin\" \n                src=\"//a.shukriya90.com/api/spots/350625?p=1&s1=".concat(Flix.ads.iid, "&kw=").concat(Flix.ads.tags, "\"></iframe>");
    }
    document.querySelector('#desktop_video_footer_ad').innerHTML = code;
  }
  ;
})();